<template>
  <div>
    <h5>划扣信息</h5>
    <div class="card" v-for="(item, index) in childData " :key="index">
      <el-form-item label-width="100" label="当日扣除项目">
        <el-select disabled @keydown.enter.native="enterDoctor($event, 6, index)" default-first-option ref="mus"
          @focus="musFocus" clearable v-model="item.musProjectId" @input="testSX" placeholder="请选择当日扣除项目" filterable
          :filter-method="projectMatch">
          <el-option v-for="(item) in newData" :key="item.id" :label="item.project" :value="item.id"></el-option>
        </el-select>
      </el-form-item>
      <el-form-item label="仪器" :prop="'musInformationList.' + index + '.instrumentNo'" :rules="rules.instrumentNo">
        <el-select @input="testSX" v-model="item.instrumentNo" clearable filterable placeholder="请选择仪器">
          <el-option v-for="(item) in item.instruments" :key="item.id" :label="item.instrumentName"
            :value="item.id"></el-option>
        </el-select>
      </el-form-item>
      <el-form-item label="划扣补充">
        <el-input @input="testSX" clearable v-model="item.musReplenish" placeholder="请输入划扣补充"></el-input>
      </el-form-item>
      <el-form-item label="诊断">
        <el-input @input="testSX" clearable v-model="item.diagnosisName" placeholder="请输入诊断"></el-input>
      </el-form-item>
      <el-form-item label-width="100" label="当日划扣金额">
        <div class="little">
          <el-input @input="testSX" disabled clearable v-model="item.musAmt" placeholder="请输入当日划扣金额"
            oninput="value=value.replace(/[^0-9.]/g, '')"></el-input>
        </div>
      </el-form-item>
      <span class="alone little">
        <el-form-item label="划扣次数" :hide-required-asterisk="true" :prop="'musInformationList.' + index + '.musContent'"
          :rules="rules.musContent">
          <el-input @input="tabInput($event, index)" clearable v-model="item.musContent" placeholder="请输入划扣次数"
            oninput="value=value.replace(/[^0-9.]/g, '')"></el-input>
        </el-form-item>
      </span>
      <span :class="item.musClass">
        <el-form-item label="划扣卡号">
          <el-input @input="testSX" oninput="value=value.replace(/[^0-9.]/g, '')" clearable v-model="item.musCode"
            placeholder="请输入划扣卡号" @change="cardChange($event, index)" @blur="cardBlur($event, index)"></el-input>
          <div class="cardNum" v-if="item.flag">划扣卡号不存在!</div>
          <span style="display:none;">{{ item.musCodeTrue }}</span>
        </el-form-item>
      </span>
      <!-- <el-form-item label="剩余次数">
        <span class="little">
          <el-input disabled clearable v-model="item.rnCount" placeholder="请输入剩余次数" oninput="value=value.replace(/[^0-9.]/g, '')"></el-input>
        </span>
      </el-form-item> -->
      <el-form-item label="备注">
        <el-input @input="testSX" clearable v-model="item.remark" placeholder="请输入备注"></el-input>
      </el-form-item>
      <div v-for="(list, idx) in item.materialList " :key="idx">
        <el-form-item label="耗材名称">
          <el-select :filter-method="((val) => { materMatch(val, index, idx) })" default-first-option ref="mater"
            @change="materChange($event, index, idx)" @focus="materFocus($event, index, idx)" @input="testSX"
            v-model="list.materialName" clearable filterable placeholder="请选择耗材名称">
            <el-option v-for="(a) in item.materList" :key="a.menuName" :label="a.menuName"
              :value="a.menuName"></el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="耗材规格">
          <el-select @input="testSX" v-model="list.materialSpec" clearable filterable placeholder="请选择耗材规格"
            @change="specChange($event, index, idx)">
            <el-option v-for="(item, index) in list.specOption" :key="index" :label="item.menuSpec"
              :value="item.menuSpec"></el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="厂家">
          <el-select @input="testSX" v-model="list.manufacturers" clearable filterable placeholder="请选择厂家"
            @change="manuChange($event, index, idx)">
            <el-option v-for="(item, index) in list.manuOption" :key="index" :label="item.manufacturers"
              :value="item.manufacturers"></el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="数量">
          <el-input @input="testSX" clearable v-model="list.number" placeholder="请输入数量"
            oninput="value=value.replace(/[^0-9.]/g, '')"></el-input>
        </el-form-item>
        <el-form-item label="实际使用">
          <el-input @input="testSX" clearable v-model="list.actualUse" placeholder="请输入"></el-input>
        </el-form-item>
        <el-button size="mini" type="danger" @click.prevent="delList(list, idx, index)">
          <!-- v-show="idx > 0" -->
          <i class="el-icon-delete"></i>
        </el-button>
      </div>
      <div>
        <el-form-item>
          <el-button @click="editList(index)" type="primary" size="mini">添加耗材</el-button>
        </el-form-item>
      </div>
      <el-form-item label="医生">
        <el-select @change="doctorChange($event, index, 'doctor')" @input="testSX" @focus="focus(1)"
          @keydown.enter.native="enterDoctor($event, 1, index)" ref="doctor" default-first-option
          :filter-method="doctorMatch" v-model="item.doctorName" clearable placeholder="请选择医生" filterable remote>
          <el-option v-for="(item) in newList1" :key="item.identityName" :label="item.identityName"
            :value="item.identityName"></el-option>
        </el-select>
      </el-form-item>
      <el-form-item label="医助">
        <el-select @change="doctorChange($event, index, 'aideName')" @input="testSX" @focus="focus(4)"
          @keydown.enter.native="enterDoctor($event, 4, index)" ref="idName" default-first-option :filter-method="bbMatch"
          v-model="item.aideName" clearable placeholder="请选择医助" filterable remote>
          <el-option v-for="(item) in newList4" :key="item.identityName" :label="item.identityName"
            :value="item.identityName"></el-option>
        </el-select>
      </el-form-item>
      <el-form-item label="护士">
        <el-select @change="doctorChange($event, index, 'nurse')" @input="testSX" @focus="focus(2)"
          @keydown.enter.native="enterDoctor($event, 2, index)" ref="nurseName" default-first-option
          :filter-method="aaMatch" v-model="item.nurseName" clearable placeholder="请选择护士" filterable remote>
          <el-option v-for="(item) in newList2" :key="item.identityName" :label="item.identityName"
            :value="item.identityName"></el-option>
        </el-select>
      </el-form-item>
      <el-form-item label="产品备注">
        <el-input @input="testSX" v-model="item.projectRemark" placeholder="请输入产品备注"></el-input>
      </el-form-item>
      <el-button size="mini" type="danger" @click.prevent="del(item, index)">
        <i class="el-icon-delete"></i>
      </el-button>
    </div>
  </div>
</template>
<script>
import { mapState, mapGetters } from 'vuex'
import { log } from 'util';
export default {
  computed: {
    ...mapState(['statusOptions', 'floorOptions', 'areaOptions']),
    ...mapGetters(['list1', 'list2', 'list4', 'productOptions', 'materiaOption', 'instructmentList']),
  },
  props: ['childData', 'rowId', 'formData'],
  data() {
    var checkMus = (rule, value, callback) => {
      if (value) {
        if (isNaN(value) == true) {
          if (value != '包年') {
            if (value != '包月') {
              callback(new Error('划扣次数格式不正确!'));
            } else {
              callback();
            }
          } else {
            callback();
          }
        } else if (isNaN(value) == false) {
          callback();
        }
      }
      callback();
    };
    return {
      newData: [],
      newList1: [],
      newList2: [],
      newList4: [],
      newOption: [],
      rules: {
        musContent: [
          { required: true, validator: checkMus, trigger: 'blur', }
        ],
        instrumentNo: [{ required: true, message: "请添加项目名称", trigger: "blur" }],
      },
      copyData: {},
    }
  },
  created() {
    busPhone.$on('busList', val => { // 接收值
      this.childData = val
      this.assign(this.childData)
    })
    this.newList1 = this.$store.state.list1
    this.newList2 = this.$store.state.list2
    this.newList4 = this.$store.state.list4
    this.newData = this.$store.getters.productOptions;
    this.newOption = this.$store.getters.materiaOption;
    busPhone.$on('tableId', val => { // 接收值
      let index = this.childData.findIndex(item => item.purchaseId === val)
      if (index != -1) {
        this.childData.splice(index, 1);
      }
    })

  },
  watch: {
    childData: {
      handler(newValue, oldValue) {
        if (newValue) {
          newValue.forEach(ele => {
            ele.doctorId = ''
            ele.nurseId = ''
            // 判断医助和护士是否是一个人
            this.newList4.forEach(item => {
              if (item.identityName == ele.aideName) {
                ele.doctorId = item.empNameNo
              }
            });
            this.newList2.forEach(item => {
              if (item.identityName == ele.nurseName) {
                ele.nurseId = item.empNameNo
                console.log(ele.nurseId);
              }
            });
            ele.instruments = []
            ele.consumables = []
            // 根据项目选择仪器
            this.newData.forEach(item => {
              if (item.id == ele.musProjectId) {
                // console.log(this.formData.earId);
                // 匹配项目下的仪器
                ele.arr = item.instrumentMenuList
                ele.arr.forEach(list => {
                  // console.log(list.areaId);
                  if (list.areaId.includes(this.formData.earId)) {
                    ele.instruments.push(list)
                  }
                });
                console.log(ele.instruments);
                if (ele.instruments.length == 0) {
                  ele.instruments.push({
                    instrumentName: '无',
                    id: 0,
                  })
                }

                // 匹配项目下的耗材
                ele.arr1 = item.consumableMenuList
                ele.arr1.forEach(list => {
                  if (list.areaId == undefined || list.areaId.includes(this.formData.earId)) {
                    ele.consumables.push(list)
                  }
                });
                ele.materList = ele.consumables
              }
            });

            if (ele.musCodeTrue == 1) {
              ele.flag = true
              ele.musClass = 'musCode'
            } else if (ele.musCodeTrue == 0) {
              ele.flag = false
              ele.musClass = ''
            }
            if (parseInt(ele.residueNumber) - parseInt(ele.musContent) < 0) {
              ele.musContent = 1
              // 剩余次数
              ele.rnCount = parseInt(ele.residueNumber) - parseInt(ele.musContent)
              // 当日划扣金额
              if (ele.residueNumber == ele.musContent && ele.amt) {
                ele.musAmt = (ele.projectAmt - ele.amt).toFixed(2)
              } else {
                ele.musAmt = (ele.unitPrice * ele.musContent).toFixed(2)
              }
              _g.toast('warning', '已无划扣次数')
              return;
            } else if (parseInt(ele.residueNumber) - parseInt(ele.musContent) >= 0) {
              // 剩余次数
              ele.rnCount = parseInt(ele.residueNumber) - parseInt(ele.musContent)
              // 当日划扣金额
              if (ele.residueNumber == ele.musContent && ele.amt) {
                ele.musAmt = (ele.projectAmt - ele.amt).toFixed(2)
              } else {
                ele.musAmt = (ele.unitPrice * ele.musContent).toFixed(2)
              }
            }


          });
        }
      },
      immediate: true,
      deep: true,

    }
  },
  methods: {
    assign(newValue) {
      newValue.forEach(ele => {
        ele.instruments = []
        ele.consumables = []
        // 根据项目选择仪器
        this.newData.forEach(item => {
          if (item.id == ele.musProjectId) {
            // console.log(this.formData.earId);
            ele.arr = item.instrumentMenuList
            ele.arr.forEach(list => {
              // console.log(list.areaId);
              if (list.areaId.includes(this.formData.earId)) {
                ele.instruments.push(list)
              }
            });
            if (ele.instruments.length == 0) {
              ele.instruments.push({
                instrumentName: '无',
                id: 9999999,
              })
            }
            // 匹配项目下的耗材
            ele.arr1 = item.consumableMenuList
            ele.arr1.forEach(list => {
              if (list.areaId == undefined || list.areaId.includes(this.formData.earId)) {
                ele.consumables.push(list)
              }
            });
            ele.materList = ele.consumables
            // console.log(ele.instruments);
          }
        });

        if (ele.musCodeTrue == 1) {
          ele.flag = true
          ele.musClass = 'musCode'
        } else if (ele.musCodeTrue == 0) {
          ele.flag = false
          ele.musClass = ''
        }
        if (parseInt(ele.residueNumber) - parseInt(ele.musContent) < 0) {
          ele.musContent = 1
          // 剩余次数
          ele.rnCount = parseInt(ele.residueNumber) - parseInt(ele.musContent)
          // 当日划扣金额
          if (ele.residueNumber == ele.musContent && ele.amt) {
            ele.musAmt = (ele.projectAmt - ele.amt).toFixed(2)
          } else {
            ele.musAmt = (ele.unitPrice * ele.musContent).toFixed(2)
          }
          _g.toast('warning', '已无划扣次数')
          return;
        } else if (parseInt(ele.residueNumber) - parseInt(ele.musContent) >= 0) {
          // 剩余次数
          ele.rnCount = parseInt(ele.residueNumber) - parseInt(ele.musContent)
          // 当日划扣金额
          if (ele.residueNumber == ele.musContent && ele.amt) {
            ele.musAmt = (ele.projectAmt - ele.amt).toFixed(2)
          } else {
            ele.musAmt = (ele.unitPrice * ele.musContent).toFixed(2)
          }
        }

      });
    },
    tabInput(val, index) {
      this.$forceUpdate()
      // console.log(val);
      this.childData.forEach(ele => {
        if (val && val == 0) {
          ele.musContent = 1
          // 剩余次数
          ele.rnCount = parseInt(ele.residueNumber) - parseInt(ele.musContent)
          // 当日划扣金额
          if (ele.residueNumber == ele.musContent && ele.amt) {
            ele.musAmt = (ele.projectAmt - ele.amt).toFixed(2)
          } else {
            ele.musAmt = (ele.unitPrice * ele.musContent).toFixed(2)
          }
        } else if (val != 0) {
          if (parseInt(ele.residueNumber) - parseInt(ele.musContent) < 0) {
            ele.musContent = 1
            // 剩余次数
            ele.rnCount = parseInt(ele.residueNumber) - parseInt(ele.musContent)
            // 当日划扣金额
            if (ele.residueNumber == ele.musContent && ele.amt) {
              ele.musAmt = (ele.projectAmt - ele.amt).toFixed(2)
            } else {
              ele.musAmt = (ele.unitPrice * ele.musContent).toFixed(2)
            }
            _g.toast('warning', '已无划扣次数')
            return;
          } else if (parseInt(ele.residueNumber) - parseInt(ele.musContent) >= 0) {
            // 剩余次数
            ele.rnCount = parseInt(ele.residueNumber) - parseInt(ele.musContent)
            // 当日划扣金额
            if (ele.residueNumber == ele.musContent && ele.amt) {
              ele.musAmt = (ele.projectAmt - ele.amt).toFixed(2)
            } else {
              ele.musAmt = (ele.unitPrice * ele.musContent).toFixed(2)
            }
          }
        }

      });
    },
    musFocus() {
      this.newData = this.productOptions;
    },
    sing() {
      this.newData = this.$store.getters.productOptions;
    },
    focus(val) {
      if (val == 1) {
        this.newList1 = this.list1
      } else if (val == 2) {
        this.newList2 = this.list2
      } else if (val == 4) {
        this.newList4 = this.list4
      }
    },
    // 划扣卡号查询提示
    cardBlur(e, index) {
      // musCodeTrue：划扣卡号是否存在 0、存在  1、不存在
      if (this.childData[index].musCode && this.childData[index].musCode != '') {
        let data = {
          cadCode: this.childData[index].musCode,
          pageSize: 1
        }
        api.requestQuiet("/skn/getClientInformation", data, (res) => {
          if (res.result == true) {
            if (res.data.mapList.length == 0) {
              this.childData[index].musCodeTrue = 1
              this.childData[index].flag = true
              this.childData[index].musClass = 'musCode'
            } else {
              this.childData[index].flag = false
              this.childData[index].musClass = ''
              this.childData[index].musCodeTrue = 0
            }
          } else {
            this.childData[index].musCodeTrue = 1
            this.childData[index].flag = true
            this.childData[index].musClass = 'musCode'
            this.$forceUpdate()
          }
        }, (err) => {
        });
      }
    },
    cardChange(e, index) {
      if (e == '' || !e) {
        this.childData[index].flag = false
        this.childData[index].musClass = ''
      }
    },
    testSX() {
      this.$forceUpdate()
    },
    projectMatch(val) {
      this.newData = _g.paramMatch(this.productOptions, this.newData, val, 'project')
    },
    doctorMatch(val) {
      this.newList1 = _g.paramMatch(this.list1, this.newList1, val, 'identityName')
    },
    aaMatch(val) {
      this.newList2 = _g.paramMatch(this.list2, this.newList2, val, 'identityName')
    },
    bbMatch(val) {
      this.newList4 = _g.paramMatch(this.list4, this.newList4, val, 'identityName')
      console.log(this.newList4);
    },
    materMatch(val, index, idx) {
      this.childData[index].materList = _g.paramMatch(this.childData[index].consumables, this.childData[index].materList, val, 'menuName')
      this.$forceUpdate()
    },
    materFocus(val, index, idx) {
      this.childData[index].materList = this.childData[index].consumables
      this.$forceUpdate()
    },
    materChange(val, index, idx) {
      this.childData[index].materialList[idx].price = ''
      this.childData[index].materialList[idx].materialSpec = ''
      this.childData[index].materialList[idx].manufacturers = '无'
      this.childData[index].materialList[idx].number = 1
      // console.log(this.childData[index].consumables);
      this.childData[index].consumables.forEach(ele => {
        if (val == ele.menuName) {
          this.childData[index].materialList[idx].specOption = ele.menuSpecList
          this.childData[index].materialList[idx].printProjectNo = ele.printProjectNo
        }
      });
      if (this.childData[index].materialList[idx].materialName == '') {
        this.childData[index].materialList[idx].specOption = []
        this.$forceUpdate()
      }
    },

    specChange(val, index, idx) {
      this.childData[index].materialList[idx].price = ''
      this.childData[index].materialList[idx].manufacturers = ''
      this.childData[index].materialList[idx].specOption.forEach(ele => {
        if (val == ele.menuSpec) {
          this.childData[index].materialList[idx].manuOption = ele.manufacturersList
        }
      });
    },
    manuChange(val, index, idx) {
      this.childData[index].materialList[idx].manuOption.forEach(ele => {
        if (val == ele.manufacturers) {
          this.childData[index].materialList[idx].materialId = ele.id
          this.childData[index].materialList[idx].price = ele.price
          this.childData[index].materialList[idx].accountingPrice = ele.accountingPrice
        }
      });
    },
    doctorChange(event, index, val) {
      if (val == 'doctor') {
        this.childData[index].aideName = '无'
      } else if (val == 'aideName') {
        this.childData[index].doctorName = '无'
        this.newList4.forEach(item => {
          if (item.identityName == event) {
            this.childData[index].doctorId = item.empNameNo
          }
        });
        console.log(this.childData[index]);
        console.log(this.childData[index].doctorId);
        console.log(this.childData[index].nurseId);
        if (this.childData[index].doctorId) {
          if (this.childData[index].doctorId == this.childData[index].nurseId) {
            _g.toast('warning', '医助和护士不能为同一人!!!')
            this.childData[index].aideName = ''
          }
        }
      } else if (val == 'nurse') {
        this.newList2.forEach(item => {
          if (item.identityName == event) {
            this.childData[index].nurseId = item.empNameNo
          }
        });
        if (this.childData[index].doctorId) {
          if (this.childData[index].doctorId == this.childData[index].nurseId) {
            _g.toast('warning', '医助和护士不能为同一人!!!')
            this.childData[index].nurseName = ''
          }
        }
      }
    },
    // 编辑时删除部位
    del(item, listIndex) {
      var index = this.childData.indexOf(item)
      if (index !== -1) {
        this.childData.splice(listIndex, 1)
      }
    },
    // 编辑时新增部位
    editList(index) {
      this.childData[index].materialList.push({
        key: Date.now(),
        materialId: '',
        materialName: '',
        materialSpec: '',
        price: '',
        number: '',
        actualUse: '',
      });
      this.$forceUpdate()
    },
    // 编辑时删除部位
    delList(item, listIndex, nextIndex) {
      var index = this.childData[nextIndex].materialList.indexOf(item)
      if (index !== -1) {
        this.childData[nextIndex].materialList.splice(listIndex, 1)
      }
      this.$forceUpdate()
    },
    enterDoctor(e, val, index, idx) {
      if (val == 6) {//当日扣除项目
        if (this.newData[0] != undefined) {
          this.childData[index].musProjectId = this.newData[0].id
          this.childData[index].musProjectName = this.newData[0].project
          this.$forceUpdate()
          this.$refs.mus[0].blur()
        }
      } else if (val == 1) {//医生
        if (this.newList1[0] != undefined) {
          this.childData[index].doctorName = this.newList1[0].identityName
          this.$forceUpdate()
          this.$refs.doctor[0].blur()
        }
      } else if (val == 4) {//医生=助理
        if (this.newList4[0] != undefined) {
          this.childData[index].aideName = this.newList4[0].identityName
          this.$forceUpdate()
          this.$refs.idName[0].blur()
        }
      } else if (val == 2) {//护士
        if (this.newList2[0] != undefined) {
          this.childData[index].nurseName = this.newList2[0].identityName
          this.$forceUpdate()
          this.$refs.nurseName[0].blur()
        }
      }
    },
  }
}
</script>
<style scoped>
.card {
  background: #e0e6f0;
  border-radius: 10px;
  margin-bottom: 10px;
  padding-top: 5px;
  box-sizing: border-box;
}

.flex {
  display: flex;
  justify-content: center;
  margin-top: 30px;
}

.card>>>.el-select .el-input__inner {
  width: 180px;
  height: 30px;
  line-height: 30px;
  font-size: 12px;
}

.card>>>.el-input__inner {
  width: 180px;
  height: 30px;
  line-height: 30px;
  font-size: 12px;
}

.card>>>.el-form-item__label {
  line-height: 30px;
}

.card>>>.el-date-editor.el-input,
.el-date-editor.el-input__inner {
  width: 180px;
  height: 30px;
  line-height: 30px;
}

.card>>>.el-input__icon {
  line-height: 30px;
}

.little>>>.el-input__inner {
  width: 180px !important;
}

.little>>>.el-input--suffix .el-input__inner {
  padding: 0px 15px !important;
}

.musCode>>>.el-input__inner {
  border-color: #f56c6c;
}

.card>>>.el-button i {
  margin: 0 !important;
}

.card>>>.el-button--mini {
  margin-top: 5px;
}

.el-form-item.is-required:not(.is-no-asterisk) .el-form-item__label-wrap>.el-form-item__label:before,
.alone>>>.el-form-item.is-required:not(.is-no-asterisk)>.el-form-item__label:before {
  display: none !important;
}

.cardNum {
  color: #f56c6c;
  font-size: 12px;
}
</style>